"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledPageContainer = styled_components_1.default.div `
  .Polaris-Frame {
    background-color: transparent;
  }

  .Polaris-Page {
    padding: 0;
  }

  .Polaris-ResourceList__HeaderTitleWrapper {
    font-weight: ${config_1.fontWeights.medium};
    font-size: ${config_1.fontSizes.medium};
  }

  .Polaris-ResourceItem {
    pointer-events: none;
  }
`;
